
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MatChipsModule } from '@angular/material/chips';
import { InputTextModule } from 'primeng/inputtext';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { RouterModule } from '@angular/router';
import { InputMaskModule } from 'primeng/inputmask';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { Select } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { CKEditorModule } from 'ckeditor4-angular';

export const SHARED_IMPORTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  ConfirmDialogModule,
  TableModule,
  MultiSelectModule,
  RouterModule,
  InputTextModule,
  MatChipsModule,
  MatAutocompleteModule, 
  DragDropModule,
  BsDropdownModule,
  TimepickerModule, 
  NgbModule,
  CKEditorModule,
  ButtonModule, 
  ConfirmDialogModule, 
  PanelModule,
  InputMaskModule,
  MatIconModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  DialogModule,
  Select,
  InputNumberModule,
  MatSelectModule,
  MatExpansionModule,
  DatePicker,
  CheckboxModule
];